import { createApp } from 'vue';
// import { createPinia } from 'pinia';

import WgPlus from 'wg-plus';
import 'wg-plus/dist/index.css';
import { zhCn, en } from 'wg-plus/es/locales.mjs';
import './style/custom-wg-plus.scss';
import { i18n } from './i18n/index.js';

import './style.css';
import App from './App.vue';

import 'virtual:uno.css';
import '@unocss/reset/tailwind-compat.css';

import router from './router';
// const pinia = createPinia();
const app = createApp(App);
const language = sessionStorage.getItem('language') || 'en';

app.use(router);
app.use(i18n);
app.use(WgPlus, { locale: language === 'zh' ? zhCn : en, input: { xss: true }, PLACEHOLDER: '--' });

// app.use(pinia);

app.mount('#app');
